module.exports = __webpack_public_path__ + "static/media/18.2067ff8b.mp3";